// Slice 4: dual-panel container. Responsive — stacks vertically below 1100px to
// match prototype/admin/pages/disease-codes.html `@media (max-width: 1100px)`.
// Slide-panels and confirm modals are mounted by the page-level component once
// CRUD wiring lands (Slices 8–9).

import { DiseaseCodePanel } from './DiseaseCodePanel';
import { DiseaseGroupListPanel } from './DiseaseGroupListPanel';

export function DiseaseCodeManagementView() {
  return (
    <div
      className="flex gap-4 max-[1099px]:flex-col"
      style={{ minHeight: 'calc(100vh - 170px)' }}
    >
      <DiseaseGroupListPanel />
      <DiseaseCodePanel />
    </div>
  );
}
